/* mainnet */
export const mintMessageAddress = '0xe79C3c5492F8E3F88093a5ADd07Fd379C0266609';

/* goerli */
// export const mintMessageAddress = '0x6be3e066de54be6105b390f9e0ebe730d0e64254';
